import {IDeleteOrganisationUserPayload, IOrganisation, IOrganisationProfilePayload, IOrganisationSettings, IOrganisationUpdateCsvPayload, IOrganisationUserUpdatePayload} from "../../common/organisation";
import { updateProfile } from "./sagas";
import {ACTION_TYPES} from "./types";
export default {
    getMyOrganisation() {
        return {
            type: ACTION_TYPES.GET_MY_ORGANISATION,
        };
    },
    getOrganisationProfiles(payload: IOrganisation['alias']) {
        return {
            type: ACTION_TYPES.GET_ORGANISATION_PROFILES,
            payload,
        }
    },
    addProfile(payload: IOrganisationProfilePayload) {
        return {
            type: ACTION_TYPES.ADD_PROFILE,
            payload,
        }
    },
    deleteProfile(payload: IDeleteOrganisationUserPayload) {
        return {
            type: ACTION_TYPES.DELETE_PROFILE,
            payload,
        }
    },
    changeOrganisationSettings(payload: IOrganisationSettings) {
        return {
            type: ACTION_TYPES.CHANGE_ORGANISATION_SETTINGS,
            payload,
        }
    },
    updateProfile(payload: IOrganisationUserUpdatePayload) {
        return {
            type: ACTION_TYPES.UPDATE_PROFILE,
            payload
        }
    },
    uploadProfiles(payload: IOrganisationUpdateCsvPayload) {
        return {
            type: ACTION_TYPES.UPDATE_PROFILES,
            payload,
        }
    }
}
